import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from "react-redux";
import './index.css'

class DragInfo extends React.Component {

    render() {
        return (
            <div className="drag-info">
                <p className="mb-0">
                    {this.props.selectedContactFromDrag.length}&nbsp;
                    {this.props.selectedContactFromDrag.length > 1 ? this.props.t("contactsSelected") : this.props.t("contactSelected")}
                </p>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
      selectedContactFromDrag: state.contactReducer.selectedContactFromDrag
  }
};

export default connect(mapStateToProps)(withTranslation()(DragInfo));